import { render, staticRenderFns } from "./CollectedInformationScreen.vue?vue&type=template&id=b4c62d22&scoped=true&"
import script from "./CollectedInformationScreen.vue?vue&type=script&lang=js&"
export * from "./CollectedInformationScreen.vue?vue&type=script&lang=js&"
import style0 from "./CollectedInformationScreen.vue?vue&type=style&index=0&id=b4c62d22&prod&scoped=true&lang=css&"
import style1 from "./CollectedInformationScreen.vue?vue&type=style&index=1&id=b4c62d22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c62d22",
  null
  
)

export default component.exports